import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-masked-time-input',
  templateUrl: './masked-time-input.component.html',
  styleUrls: ['./masked-time-input.component.css']
})
export class MaskedTimeInputComponent {
  @Input() value: string;
  @Output() valueChanged = new EventEmitter<string>();

  rules = {
    A: (char: number) => char >= 0 && char <= 5,
    a: (char: number) => char >= 0 && char <= 9
  }

  onValueChanged(e: any) {
    this.value = e.value;
    this.valueChanged.emit(e.value);
  }
}
